export function projectPageUrl(region, projectId, tab) {
  const base = `/${region}/project/${encodeURIComponent(String(projectId))}`;
  return tab ? `${base}?tab=${encodeURIComponent(tab)}` : base;
}
